import ONGDash from "../../interfaces/dash";
import { useContext, useState } from "react"
import placeholder_logo from "../../assets/placeholder.jpg";
import { useNavigate } from "react-router";
import { AuthContext } from "../../context/auth";

interface UserRowProps {
    ongDashList: ONGDash[] // Changed to accept an array
}

export default function MktDashTable({
    ongDashList
}: UserRowProps) {
    
    const navigate = useNavigate();
    const userContext = useContext(AuthContext);
    const [expandedCard, setExpandedCard] = useState<number | null>(null);

    function sendOne(id: string) {
        let token: string = "";

        if (localStorage.getItem("USER_TOKEN") !== null) {
            token = localStorage.getItem("USER_TOKEN")!;
        }

        fetch(`${userContext?.api_url}/company/listZeroComp`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify({
                fk_id_usuario: id
            })
        }).then(resp => {
            if (resp.status >= 400) {
                console.log(resp);
            } else {
                resp.json().then(jsonResponse => {
                    localStorage.setItem('id', id);
                    navigate('/dashboard/previewp0c');
                })
            }
        }).catch((err) => {
            console.log(err);
        })
    }

    return (
        <div className="w-full p-4 bg-principal-3 overflow-auto">
            <div className="overflow-x-auto shadow-md rounded-lg">
                <h1 className="text-2xl md:text-3xl font-semibold text-center text-principal-2 uppercase mb-5">
                    COMPAÑÍAS DISPONIBLES
                </h1>
                
                {/* Mobile view - Card format */}
                <div className="md:hidden">
                    {ongDashList.map((ongDash, idx) => (
                        <div key={`mobile-card-${idx}`} className="bg-white rounded-lg shadow mb-4 p-4">
                            <div className="flex justify-between border-b pb-2 mb-2">
                                <span className="font-bold text-black">ID:</span>
                                <span className="text-black">{String(ongDash.id)}</span>
                            </div>
                            <div className="flex justify-between border-b pb-2 mb-2">
                                <span className="font-bold text-black">Nombre:</span>
                                <span className="text-black">{String(ongDash.nombre)}</span>
                            </div>
                            <div className="flex justify-between border-b pb-2 mb-2">
                                <span className="font-bold text-black">Dirección:</span>
                                <span className="text-black">{String(ongDash.direccion)}</span>
                            </div>
                            <div className="flex justify-between border-b pb-2 mb-2">
                                <span className="font-bold text-black">Teléfono:</span>
                                <span className="text-black">{String(ongDash.telefono)}</span>
                            </div>
                            
                            <button 
                                className="mt-3 bg-principal-1 text-white py-2 px-4 rounded w-full"
                                onClick={() => setExpandedCard(expandedCard === idx ? null : idx)}
                            >
                                {expandedCard === idx ? 'Ocultar logo' : 'Ver logo'}
                            </button>

                            {expandedCard === idx && (
                                <div className="mt-4">
                                    <img
                                        className="w-full h-48 object-contain mx-auto"
                                        src={`https://ctaauditores.com/wp-content/uploads/plataforma_cta/archivos/${ongDash.id}/${ongDash.logo}`}
                                        alt={`Logo de ${ongDash.nombre}`}
                                        onError={(e) => {
                                            e.currentTarget.src = placeholder_logo;
                                        }}
                                    />
                                </div>
                            )}
                            
                            <button
                                className="mt-4 w-full bg-principal-1 text-white font-medium py-3 px-4 rounded transition-colors hover:bg-opacity-90 focus:outline-none focus:ring focus:ring-principal-1 focus:ring-opacity-50"
                                onClick={() => sendOne(String(ongDash.id))}
                            >
                                Consultar
                            </button>
                        </div>
                    ))}
                </div>
                
                {/* Desktop view - Table format */}
                <div className="hidden md:block">
                    <div className="overflow-x-auto">
                        <table className="table-auto w-full font-roboto text-black border-collapse">
                            <thead className="text-xs font-semibold uppercase text-principal-2 bg-principal-1">
                                <tr>
                                    <th className="p-2">
                                        <div className="font-semibold text-center">ID</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-center">Logo</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-center">Nombre</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-center">Dirección</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-center">Teléfono</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-center">Acción</div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="text-sm divide-y divide-gray-100 bg-white">
                                {ongDashList.map((ongDash, idx) => (
                                    <tr key={`desktop-row-${idx}`}>
                                        <td className="p-2">
                                            <div className="font-medium text-center">{String(ongDash.id)}</div>
                                        </td>
                                        <td className="p-2">
                                            <div className="flex justify-center">
                                                <img
                                                    className="w-16 h-16 object-contain"
                                                    src={`https://ctaauditores.com/wp-content/uploads/plataforma_cta/archivos/${ongDash.id}/${ongDash.logo}`}
                                                    alt={`Logo de ${ongDash.nombre}`}
                                                    onError={(e) => {
                                                        e.currentTarget.src = placeholder_logo;
                                                    }}
                                                />
                                            </div>
                                        </td>
                                        <td className="p-2">
                                            <div className="font-medium text-center">{String(ongDash.nombre)}</div>
                                        </td>
                                        <td className="p-2">
                                            <div className="font-medium text-center">{String(ongDash.direccion)}</div>
                                        </td>
                                        <td className="p-2">
                                            <div className="font-medium text-center">{String(ongDash.telefono)}</div>
                                        </td>
                                        <td className="p-2">
                                            <div className="flex justify-center">
                                                <button
                                                    className="bg-principal-1 text-white font-medium py-2 px-3 rounded transition-colors hover:bg-opacity-90 focus:outline-none focus:ring focus:ring-principal-1 focus:ring-opacity-50"
                                                    onClick={() => sendOne(String(ongDash.id))}
                                                >
                                                    Consultar
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}